module.exports = __webpack_public_path__ + "img/hoodie.d633d3fd.svg";